import ModalUtil from 'common/util/ModalUtil';
import ObserverUtil from 'common/util/ObserverUtil';

export default () => {
    const AddGifts = Component(function ($context) {
        return $context.select('.addgifts');
    }, function ($addGifts, self) {

        function init() {
            const templateModal = $addGifts.find('#addgifts-modal__content');

            if (!templateModal.length) {
                return;
            }

            self.modal = $addGifts.find('#addgifts-modal__content').prop('content').cloneNode(true).firstElementChild;
            self.modalItem = $addGifts.find('#addgifts-modal__item').prop('content').cloneNode(true).firstElementChild;
            initEventListeners();
        }

        function initEventListeners() {
            $addGifts.on('click', '.addgifts__change-gift', function () {
                const $btn = $(this);
                const $currentItem = $btn.closest('.addgifts__gift');
                const currentItemId = $currentItem.find('.js-addgifts__gift--select_gift').val()
                const gifts = $btn.data('gifts');
                const $modal = $(self.modal.cloneNode(true));
                const $content = $modal.find('.addgifts-modal__content');

                for (const key in gifts) {
                    const item = gifts[key];

                    if (item.index == currentItemId) {
                        continue;
                    }

                    const $item = $(self.modalItem.cloneNode(true));
                    const $imageItem = $item.find('.addgifts-modal__item-img');
                    const $linkItem = $item.find('.addgifts-modal__item-name');
                    $linkItem.prop('href', '/' + item.url);
                    $linkItem.text(item.product_name);
                    $imageItem.prop('src', item.url_modal_image);
                    $imageItem.prop('alt', item.product_name);
                    $item.find('.addgifts-modal__item-compare-price').html(item.price);
                    $item.find('.addgifts-modal__item-btn').on('click', function () {
                        setTimeout(() => ModalUtil.close(), 300);
                        const $modalItemBtn = $(this);
                        $modalItemBtn.addClass('addgifts-modal__item-btn_selected');
                        replaceProduct(item, $currentItem)
                    })
                    $content.append($item);
                }
                ModalUtil.openContent($modal)
            });
        }

        function replaceProduct(targetItem, $currentItem) {
            const $input = $currentItem.find('.js-addgifts__gift--select_gift');
            $input.val(targetItem.index);
            $input.data('gift-index', targetItem.index)
            $input.data('gift-product', targetItem.product_name);
            $input.prop('checked', true);
            $input.trigger('change')

            if ($input.data('cart-input')) {
                return;
            }

            const $img = $currentItem.find('.addgifts__img');
            const srcSet = `${targetItem.url_image} 1x, ${targetItem.url_image.replace(/\.(?=[^.]*$)/, '@2x.')} 2x`;
            $img.prop('src', targetItem.url_image);
            $img.prop('alt', targetItem.product_name);
            $img.data('srcset', srcSet);
            $img.prop('srcset', srcSet);

            const $link = $currentItem.find('.addgifts__link');
            $link.prop('href', '/' + targetItem.url);
            $link.text(targetItem.product_name);

        }

        init();
    })

    ObserverUtil.observeComponent('addgifts', AddGifts);

    return AddGifts;
};
